(() => {
  const isPdp = Boolean(
    (document.body && document.body.classList.contains('template-product')) ||
    document.querySelector('product-info[data-product-id], [data-product-id][data-url^="/products/"], form[action*="/cart/add"]') ||
    /^\/products\//.test(window.location.pathname)
  );
  if (!isPdp) return;

  const hideShell = (shell) => {
    if (!(shell instanceof HTMLElement) || shell.hasAttribute('data-pp-hidden-bundler-pdp')) return;
    shell.setAttribute('hidden', '');
    shell.style.setProperty('display', 'none', 'important');
    shell.setAttribute('data-pp-hidden-bundler-pdp', 'true');
  };

  const suppress = () => {
    // Bundler is injecting automatic package widgets into ordinary product pages.
    // These belong on /pages/package or /a/bundles/*, not below the PDP accordions.
    document.querySelectorAll('.bundler-target-element.bndlr-automatic').forEach(hideShell);

    // Cover already-rendered children if Bundler inserts inner containers after the shell scan.
    document.querySelectorAll('.bndlr-container, .bndlr-products-container').forEach((node) => {
      const shell = node.closest('.bundler-target-element') || node;
      hideShell(shell);
    });
  };

  const start = () => {
    suppress();
    const observer = new MutationObserver(suppress);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    [100, 300, 750, 1500, 3000, 6000, 10000].forEach((delay) => window.setTimeout(suppress, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
